import { render, staticRenderFns } from "./EsNotification.vue?vue&type=template&id=4a459df6&scoped=true&"
import script from "./EsNotification.vue?vue&type=script&lang=js&"
export * from "./EsNotification.vue?vue&type=script&lang=js&"
import style0 from "./EsNotification.vue?vue&type=style&index=0&id=4a459df6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a459df6",
  null
  
)

export default component.exports